export default "__VITE_ASSET__CxiE2GK9__"